module.exports = __webpack_public_path__ + "static/img/moaUninstall_pic03.c0ba923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaUninstall/moaUninstall_pic03.png
// module id = 548
// module chunks = 1